import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { logUserAction } from '@office-start/telemetry-service';
import { BehaviorSubject } from 'rxjs';
var inputDialogObject = new BehaviorSubject(null);
export function observeOneNoteDialog() {
    return inputDialogObject.asObservable();
}
export function showOneNoteDialog(oneNoteDialog) {
    inputDialogObject.next(oneNoteDialog);
    logUserAction({
        eventName: KnownInstrumentationEvents.OpenCreateNewNotebookDialog,
        id: 'OneNoteNotebookCreateLink',
        area: 'InputDialog',
        subArea: 'CreateLinks',
        result: 'Open',
        target: 'Other',
    });
}
export function closeOneNoteNotebookDialog() {
    inputDialogObject.next(null);
}
//# sourceMappingURL=NotebookDialogOperations.js.map